/* ============================================================
   バリエーション（カラー）別 画像出し分け
   ------------------------------------------------------------
   運用ルール：
   - 「全カラー共通で常に表示」したい画像は alt を空にする。
   - カラー別に出し分けたい画像は、alt にカラー名（バリエーション値。
     例「ピンク」「BLACK」）を入れる。

   判定（data-vmf-config の productColors / knownColors を使用）：
   - alt が空                                   → 常に表示（共通）
   - alt がカラー名(knownColors)で、この商品の
     バリエーションに存在する(productColors)     → そのカラー選択時のみ表示
   - alt がカラー名(knownColors)だが、この商品の
     バリエーションに存在しない                   → 非表示（出力しない）
   - alt がカラー名でない（説明文など）          → 常に表示（誤って隠さない）

   ※ data-vmf-config が無いページでは、従来どおり alt からカラーを推測する
     フォールバック動作（共通/選択カラー表示のみ・非表示判定なし）。
   ============================================================ */
(function () {
  'use strict';

  var HIDDEN = 'vmf-hidden';

  function injectStyle() {
    if (document.getElementById('vmf-style')) return;
    var s = document.createElement('style');
    s.id = 'vmf-style';
    s.textContent = '.' + HIDDEN + '{display:none !important;}';
    document.head.appendChild(s);
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function lowerList(arr) {
    return (Array.isArray(arr) ? arr : [])
      .map(function (v) {
        return String(v).trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function readVariants(vs) {
    return readJSON(vs.querySelector('script[type="application/json"]'));
  }

  // Dawn の VariantSelects.updateOptions と同じ要領で現在の選択値を取得
  function currentOptions(vs) {
    return Array.prototype.map.call(vs.querySelectorAll('select, fieldset'), function (el) {
      if (el.tagName === 'SELECT') return el.value;
      var checked = Array.prototype.filter.call(el.querySelectorAll('input'), function (r) {
        return r.checked;
      })[0];
      return checked ? checked.value : null;
    });
  }

  function altOf(el) {
    var img = el.tagName === 'IMG' ? el : el.querySelector('img');
    return ((img && img.getAttribute('alt')) || '').trim().toLowerCase();
  }

  // alt に含まれる色（list 内）を返す。無ければ null。
  function matchColor(alt, list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] && alt.indexOf(list[i]) !== -1) return list[i];
    }
    return null;
  }

  function setupSection(vs) {
    var root = vs.closest('.shopify-section') || document;
    var sectionId = vs.dataset.section;

    // 確定情報（Liquid出力）：この商品のカラー値 と ブランドの色名リスト
    var config = readJSON(root.querySelector('[data-vmf-config]'));
    var productColors, knownColors, definitive;

    if (config) {
      productColors = lowerList(config.productColors);
      knownColors = lowerList(config.knownColors);

      // 保険：カラーのオプション名が想定外でproductColorsが空でも、
      // variantsの各オプション値のうち色名リストに該当するものをこの商品のカラーとみなす
      if (!productColors.length && knownColors.length) {
        var vs2 = readVariants(vs);
        if (vs2 && vs2.length && vs2[0].options) {
          var detected = [];
          var oc = vs2[0].options.length;
          for (var oi = 0; oi < oc; oi++) {
            vs2.forEach(function (v) {
              var val = (v.options[oi] == null ? '' : String(v.options[oi])).trim().toLowerCase();
              if (val && knownColors.indexOf(val) !== -1 && detected.indexOf(val) === -1) {
                detected.push(val);
              }
            });
          }
          productColors = detected;
        }
      }

      // 色名リストが空なら、誤判定防止のため productColors のみを既知色とする
      if (!knownColors.length) knownColors = productColors.slice();
      definitive = true;
    } else {
      // フォールバック：variants から alt 推測でカラー値を検出（従来動作）
      var variants = readVariants(vs);
      if (!variants || !variants.length || !variants[0].options) return;
      var optCount = variants[0].options.length;
      var optValues = [];
      for (var i = 0; i < optCount; i++) {
        var vals = [];
        variants.forEach(function (v) {
          var val = v.options[i];
          if (val != null && vals.indexOf(val) === -1) vals.push(val);
        });
        optValues.push(vals);
      }
      var allAlts = Array.prototype.map.call(root.querySelectorAll('.product__media-item'), altOf);
      var colorIndex = -1;
      var best = 0;
      for (var p = 0; p < optCount; p++) {
        var m = 0;
        optValues[p].forEach(function (val) {
          var v = String(val).trim().toLowerCase();
          if (v.length >= 2 && allAlts.some(function (a) { return a.indexOf(v) !== -1; })) m++;
        });
        if (m > best) { best = m; colorIndex = p; }
      }
      if (colorIndex === -1) return;
      productColors = lowerList(optValues[colorIndex]).filter(function (v) { return v.length >= 2; });
      knownColors = productColors.slice(); // フォールバックでは非表示判定はしない
      definitive = false;
    }

    function selectedColor() {
      var opts = currentOptions(vs).map(function (v) { return (v || '').trim().toLowerCase(); });
      for (var i = 0; i < opts.length; i++) {
        if (productColors.indexOf(opts[i]) !== -1) return opts[i];
      }
      return null;
    }

    function apply(el, selected) {
      var alt = altOf(el);
      var visible;
      if (!alt) {
        visible = true; // alt無し＝共通
      } else {
        var pc = matchColor(alt, productColors); // この商品にあるカラー
        if (pc) {
          visible = pc === selected; // 選択中カラーのみ
        } else {
          var kc = matchColor(alt, knownColors); // ブランドの色名だが、この商品に無い
          if (kc && definitive) {
            visible = false; // 新要件：存在しないカラーのalt → 非表示
          } else {
            visible = true; // 色名でないalt（説明文等）→ 常に表示
          }
        }
      }
      el.classList.toggle(HIDDEN, !visible);
    }

    // 表示中（alt一致）の先頭メディアをアクティブにしてビューアをそこへ。
    // Shopify標準の updateMedia は無効化済みなので、カラー切替の表示はここが担う。
    function activateFirstVisible() {
      root.querySelectorAll('media-gallery').forEach(function (g) {
        if (typeof g.setActiveMedia !== 'function') return;
        var first = Array.prototype.filter.call(
          g.querySelectorAll('.product__media-item'),
          function (el) { return !el.classList.contains(HIDDEN); }
        )[0];
        if (first && first.dataset.mediaId) {
          try { g.setActiveMedia(first.dataset.mediaId, false); } catch (e) {}
        }
      });
    }

    var lastSelected;
    function filter(isInit) {
      var selected = selectedColor();
      root.querySelectorAll('.product__media-item').forEach(function (el) { apply(el, selected); });
      root.querySelectorAll('.thumbnail-list__item').forEach(function (el) { apply(el, selected); });
      if (sectionId) {
        var modal = document.getElementById('ProductModal-' + sectionId);
        if (modal) {
          modal.querySelectorAll('.product-media-modal__content img').forEach(function (img) { apply(img, selected); });
        }
      }
      // カラーが変わった時（と初期表示）だけ、表示中の先頭画像へ切替。
      // サイズ変更ではカラーが変わらない＝画像は切り替わらない。
      if (isInit || selected !== lastSelected) {
        activateFirstVisible();
      }
      lastSelected = selected;
    }

    filter(true);
    vs.addEventListener('change', function () {
      window.setTimeout(function () { filter(false); }, 0);
    });
  }

  function init() {
    injectStyle();

    // Shopify標準の「バリアント画像で先頭表示/切替」を無効化。
    // 画像の出し分けは alt＋カラーボタン（このフィルタ）だけにする。
    // （サイズ等カラー以外の選択で画像が切り替わるのを防ぐ）
    try {
      if (typeof VariantSelects !== 'undefined' && VariantSelects.prototype) {
        VariantSelects.prototype.updateMedia = function () {};
      }
    } catch (e) {}

    document.querySelectorAll('variant-selects').forEach(setupSection);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
